module.exports = __webpack_public_path__ + "static/unternehmen-intro-img-00b595b38eb0d8f74cf9be0e404f49e1.png";